import {LocaleDictionaryPassport} from "../../interface/passport";

export const passport:  LocaleDictionaryPassport = {
    change_personal_notification : 'ФИО и дата рождения как в документе, удостоверяющим личность. Это необходимо для того, чтобы Вы получили доступ ко всем сервисам РУДН',
    save_and_continue: 'Сохранить и продолжить',
    save: 'Сохранить',
    cancel: 'Отмена',
    account: 'Аккаунт',
    goToLK: 'Перейти в личный кабинет работника/обучающегося',
    goToAB: 'Перейти в личный кабинет абитуриента',
    registrationForm: {
        title: 'Регистрация',
        haveAccount : {
            name: 'Уже есть аккаунт RUDN ID?'
        },
        loginButton: {
            name: 'Войти'
        },
        emailForm: {
            hint: 'Электронная почтa'
        },
        citizenshipSelect: {
            title: 'Документ, удостоверяющий личность'
        },
        surnameForm: {
            hint: 'Фамилия'
        },
        nameForm: {
            hint: 'Имя'
        },
        patronymicForm: {
            hint: 'Отчество/Среднее имя (при наличии)'
        },
        birthdateForm: {
            title: 'Дата рождения',
            day: 'День',
            month: 'Месяц',
            year: 'Год'
        },
        passportSeriasForm: {
            title: 'Серия',
        },
        passportNumberForm: {
            title: 'Номер'
        },
        continueButton: {
            name: 'Продолжить'
        },
        phoneConfirm: {
            name: 'Подтвердить номер телефона',
            callback: {
                name:  "Ожидаем звонка на номер {{phone}}"
            },
            changePhoneButton: {
                name: 'Изменить'
            },
            confirm: {
                text: "Номер {{phone}} подтвержден"
            },
            chooseConfirmWay: 'Выберите вариант подтверждения:',
            success: 'Номер подтвержден!',
            errorConfirm: 'Не удалось подтвердить номер телефона!',
            thanks: 'Хорошо, спасибо',
            waitingForCall: 'Ждем звонка с номера',
            processingCall: 'Обрабатываем Ваш звонок',
            codeActive: 'Ожидаем вашего звонка до истечения времени',
            changeWay: 'Изменить способ подтверждения',
            operationSuccess: 'Операция выполнена успешно',
            formWillBeUpdated: 'Как только мы получим звонок, форма обновится автоматически',
            freeCallNumber: 'Бесплатный звонок по номеру',
            resendCode: 'Отправить код повторно',
            willBeCall: 'Поступит звонок на номер',
            smsSentTo: 'Отправили смс на номер',
        },
        callbackAlert: {
            title: 'Подтверждение номера телефона',
            choose_option:'Выберите вариант подтверждения:',
            textinfo_1:'Для продолжения регистрации вам необходимо подтвердить номер мобильного телефона',
            textinfo_2: 'Вам поступит звонок на номер',
            textinfo_3: 'Введите последние 4 цифры номера телефона входящего звонка',
            buttonConfirm: {
                name: 'Понятно'
            }
        },
        callbackByUserAlert: {
            title: 'Нам не удалось связаться с вами',
            textinfo_1: 'Вы можете подтвердить свои персональные данные позвонив по номеру',
            textinfo_2: 'Звонок для вас бесплатный, он сбросится автоматически после ряда гудков, после этого ваши данные будут подтверждены',
            buttonConfirm: {
                name: 'Понятно',
            }
        },
        inputCodeForm: {
            title: 'Введите код'
        },
        codetimer: {
            text: "Пытаемся с вами связаться"
        },
        passwordForm: {
            text: "Пароль должен состоять из 9 и более символов, включая цифры, прописные и заглавные буквы латинского алфавита, специальные символы из списка ([@#$%^&*])+!-_",
        }
    }
}
